const header = document.querySelector('.header');
const articleLine = document.querySelector('.header-article-line');
const search = document.querySelector('.header__search');
const searchBtn = document.querySelector('.search-btn');

let isHeaderBecomeFixed = 0;
window.addEventListener('scroll', function (e) {
  const currentPosition = window.scrollY;

  if (currentPosition >= 30 && !isHeaderBecomeFixed) {
    isHeaderBecomeFixed = true;
    if (header.classList.contains('header_with-search')) {
      header.classList.remove("header_with-search")
      header.classList.add("header_fixed-with-search")
    }

    setTimeout(() => {
      header.classList.toggle('header_is-fixed');
      articleLine?.classList.toggle('header-article-line_is-fixed');
    }, 100);
  }

  if (currentPosition < 30 && isHeaderBecomeFixed) {
    isHeaderBecomeFixed = false;
    header.classList.toggle('header_is-fixed');
    header.classList.remove('header_fixed-with-search');
    search.classList.remove('header__search_show');
    searchBtn.querySelector('.search-btn__show-icon').classList.remove('hidden');
    searchBtn.querySelector('.search-btn__close-icon').classList.add('hidden');

    articleLine?.classList.toggle('header-article-line_is-fixed');
    articleLine?.classList.remove('hidden');
  }
});